import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../config";
import PostsMap from "../components/PostsMap";
import defaultImage from "../images/post1.jpg";

const Press = () => {
  const TRADITIONAL_CATEGORY_KEY = "traditional-popular";
  const PRESS_CATEGORY_KEY = "press";

  const [traditionalPosts, setTraditionalPosts] = useState([]);
  const [popularPosts, setPopularPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      setError(null);
      try {
        const [tradRes, popRes] = await Promise.all([
          axios.get(`${env.baseUrl}/api/posts/${TRADITIONAL_CATEGORY_KEY}`).catch(() => ({ data: { posts: [] } })),
          axios.get(`${env.baseUrl}/api/posts/${PRESS_CATEGORY_KEY}`).catch(() => ({ data: { posts: [] } })),
        ]);
        setTraditionalPosts(tradRes.data.posts?.data || tradRes.data.posts || []);
        setPopularPosts(popRes.data.posts?.data || popRes.data.posts || []);
      } catch (err) {
        console.error("Error loading press posts:", err);
        setError("Failed to load press posts.");
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const allPosts = [...traditionalPosts, ...popularPosts];

  return (
    <div className="press-page main-category-block inner-pages">
      <div className="container">
        <div className="title-block text-center">
          <h2>Press & News</h2>
        </div>

        {loading ? (
          <div className="text-center my-5">Loading press articles...</div>
        ) : error ? (
          <div className="text-center my-5 text-danger">{error}</div>
        ) : (
          <div className="md-block">
            <div className="row">
              {allPosts.map((post) => (
                <div className="col-lg-4 col-md-6 mb-4" key={post.id}>
                  <div className="post-box">
                    <div className="post-image position-relative">
                      <div className="img-block">
                        <figure className="thumbnail zoom-effect">
                          <a href={`/post/${post.slug}`}>
                            <img src={post.image || defaultImage} alt={post.title} />
                          </a>
                        </figure>
                      </div>
                      <div className="post-content">
                        <div className="post-title">
                          <h2>
                            <a href={`/post/${post.slug}`}>{post.title}</a>
                          </h2>
                        </div>
                        <div className="post-category">{post.category_id || post.category}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {allPosts.length > 0 && (
              <section className="passive-map my-5">
                <PostsMap posts={allPosts} />
              </section>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Press;
